import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/close_btn.png'


const _hoisted_1 = { class: "share-wrapper" }
const _hoisted_2 = { class: "share-inner" }
const _hoisted_3 = { class: "share-img" }
const _hoisted_4 = { class: "img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "长按图片保存到相册", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.shareImg,
            draggable: "false",
            alt: ""
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", {
          class: "share-close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, _hoisted_7)
      ]),
      _hoisted_8
    ])
  ], 512)), [
    [_vShow, _ctx.shareImg && !_ctx.isApp]
  ])
}